// src/components/store/sections/newsletter/NewsletterV103GradientbannerSlateGold.tsx
"use client";

import React from "react";
import DynamicNewsletterVariant from "./DynamicNewsletterVariant";

export default function NewsletterV103GradientbannerSlateGold(props: any) {
  return (
    <DynamicNewsletterVariant
      variantNumber={103}
      archKey="gradient_banner"
      archLabel="Gradient Accent Banner"
      palName="SlateGold"
      grad="from-slate-800 via-zinc-900 to-neutral-950"
      lightBg="bg-amber-50/80"
      textCol="text-amber-700"
      borderCol="border-amber-300"
      btnCls="bg-slate-900 hover:bg-slate-800"
      hexCol="#eab308"
      {...props}
    />
  );
}
